import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import type { InformationItem } from '../types';

interface InformationSectionProps {
  title: string;
  description: string;
  items: InformationItem[];
}

const InformationSection = ({ title, description, items }: InformationSectionProps) => (
  <section className="my-14">
    <h2 className="mb-1.5 text-3xl leading-[1.15] font-semibold tracking-tight">{title}</h2>
    <p className="mb-6 max-w-[60ch] text-muted-foreground">{description}</p>
    <div className="grid gap-[18px] min-[901px]:grid-cols-[repeat(auto-fill,minmax(250px,1fr))]">
      {items.map(item => (
        <Card key={item.title} className="block rounded-[14px] border-border border-t-[3px] border-t-[#0C30A8] px-5 py-[18px] shadow-none">
          {item.status && (
            <span className={cn(
              'mb-2.5 inline-block rounded-full px-2.5 py-0.5 text-[13px] font-semibold',
              item.inProgress ? 'bg-[#FCEEDF] text-[#9A4F0A]' : 'bg-[#E6ECFD] text-[#0C30A8]',
            )}>
              {item.status}
            </span>
          )}
          <h3 className="mb-1 text-lg font-semibold">{item.title}</h3>
          <p className="text-[15.5px] text-muted-foreground">{item.description}</p>
        </Card>
      ))}
    </div>
  </section>
);

export default InformationSection;
